import dashMutations from "./dash.mutation";
import dashStates from "./dash.state";
import dashActions from "./dash.action";

export default {
  mutations: dashMutations,
  state: dashStates,
  actions: dashActions
};
